import React from "react";
import { Link } from "react-router-dom";

export default function SearchBar({ searchTerm, handleInputChange, filteredData }) {
  return (
    <div className="col-md-4">
      <div className="search-container position-relative">
        <div className="input-group search-bar has-validation">
          <input
            name="search"
            type="text"
            className="form-control"
            placeholder="Hinted search text"
            value={searchTerm}
            onChange={handleInputChange}
          />
          <span className="input-group-text">
            <i className="fa-solid fa-magnifying-glass"></i>
          </span>
        </div>

        {filteredData.length > 0 && (
          <div className="search-results position-absolute mt-1 ">
            <ul className="list-group">
              {filteredData.map((policy, index) => (
                <Link
                  key={index}
                  to={`/details/${policy.Id}`}
                  state={{ policy }}
                  className="text-decoration-none text-dark"
                >
                  <li className="list-group-item">{policy.Name}</li>
                </Link>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
